module.exports = __webpack_public_path__ + "img/ic_add3.bffb0eae.svg";